@if (!isMobile) {
    <div class="bin-capacity-container-wrapper">
        @if(user_role_id == 5 || user_role_id == 6){
            <label class="container-extra" rtlDiv>
                <input id="isUnfilteredTransmission_chc" [(ngModel)]="isUnfilteredTransmission" [checked]="isUnfilteredTransmission" type="checkbox" (change)="unfilteredTransmissionBtn(isUnfilteredTransmission)" rtlDiv>
                <span class="checkmark" rtlDiv></span>
                <div class="chbx-title">{{ 'LIVE_INFO.UNFILTERED' | translate }}</div>
            </label>
        }
        <div [ngClass]="{'hideCmp': isUnfilteredTransmission}">
            <app-bin-filtered-samples></app-bin-filtered-samples>
        </div>
        <div [ngClass]="{'hideCmp': !isUnfilteredTransmission}">
            <app-bin-unfiltered-samples></app-bin-unfiltered-samples>
        </div>
    </div>
}

@if (isMobile) {
    
}